(function () {
  'use strict';

  var component = {
    template:'<hq-tools-lighting-header></hq-tools-lighting-header><hq-tools-lighting-wizard-bar></hq-tools-lighting-wizard-bar><div class="hq-lighting-step"><hq-tools-lighting-title data-ng-if="$ctrl.stepName === \'lumen\'" action="$ctrl.openModalLumen()" translate-key="{{$ctrl.stepName}}"></hq-tools-lighting-title><hq-tools-lighting-title id="desc-question-{{$ctrl.stepName}}" data-ng-if="$ctrl.stepName !== \'lumen\'" translate-key="{{$ctrl.stepName}}"></hq-tools-lighting-title><hq-tools-lighting-modal close-modal="$ctrl.closeModalLumen()" ng-if="$ctrl.stepName === \'lumen\' && $ctrl.active" data-translate-key="LUMENS_INFO_MODAL_CONTENT"></hq-tools-lighting-modal><div class="hq-lighting-step__content hq-lighting-step__content--selection"><slick data-ng-if="$ctrl.mobile && !($ctrl.stepName === \'base\' || $ctrl.stepName ===\'lumen\')" role="slider" aria-valuemin="0" aria-valuenow="0" aria-valuemax="{{$ctrl.options.lengt - 1}}" settings="$ctrl.slickConfig"><hq-tools-lighting-carousel-item ng-repeat="option in $ctrl.options" option="option" step-name="$ctrl.stepName" on-change="$ctrl.onChange(value)" selection="$ctrl.selection" action="$ctrl.openModal(translateKey)" zoom-modal="$ctrl.zoomModal"></hq-tools-lighting-carousel-item></slick><div data-ng-if="!$ctrl.mobile || ($ctrl.stepName === \'base\' || $ctrl.stepName ===\'lumen\')" data-ng-class="{isCentered: $ctrl.options.length <= 2}" aria-label="{{($ctrl.stepName + \'_TITLE\' | uppercase) | translate}}" aria-labelledby="desc-question-{{$ctrl.stepName}}" class="hq-lighting-list" role="radiogroup"><hq-tools-lighting-list-item ng-repeat="option in $ctrl.options" option="option" options="$ctrl.options" step-name="$ctrl.stepName" on-change="$ctrl.onChange(value)" selection="$ctrl.selection" action="$ctrl.openModal(translateKey)" zoom-modal="$ctrl.zoomModal"></hq-tools-lighting-list-item></div></div><hq-tools-lighting-footer ng-if="$ctrl.stepName !== \'base\'" translate-key="CONTINUE" disabled="{{!$ctrl.isValid && !ctrl.selection}}" sref="{{$ctrl.nextStep}}" lref="{{$ctrl.prevStep}}" sticky="{{$ctrl.isValid}}"></hq-tools-lighting-footer><hq-tools-lighting-footer ng-if="$ctrl.stepName === \'base\'" translate-key="CONTINUE" disabled="{{!$ctrl.isValid && !ctrl.selection}}" click-type="$ctrl.getTypeSelection()" lref="{{$ctrl.prevStep}}" sticky="{{$ctrl.isValid}}"></hq-tools-lighting-footer></div>',
    controller: StepSelectionController,
    bindings: {
      stepName: '<',
      nextStep: '<',
      prevStep: '<',
      zoomModal: '<',
    },
  };

  function StepSelectionController(
    hqTLightingOptions,
    hqTLightingMediaquery,
    $scope,
    $timeout
  ) {
    'ngInject';

    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.options = hqTLightingOptions[ctrl.stepName + 's'];
      ctrl.selection = hqTLightingOptions[ctrl.stepName + 'Selection'];
      ctrl.mobile = hqTLightingMediaquery.small.matches;

      ctrl.isSelectionValid = function () {
        // eslint-disable-next-line es5/no-es6-methods
        var selection = ctrl.options.find(function (item) {
          return ctrl.selection === item.translateKey;
        });

        return !!selection;
      };

      if (ctrl.selection === null) {
        ctrl.isValid = false;
      } else {
        ctrl.isValid = ctrl.isSelectionValid && ctrl.isSelectionValid();
      }


      ctrl.onChange = function (value) {
        ctrl.selection = value;
        hqTLightingOptions[ctrl.stepName + 'Selection'] = value;
        ctrl.isValid = true;
      };

      // Question mark button on title bar for the lumen step
      ctrl.openModalLumen = function () {
        ctrl.active = true;
        $timeout(function () {
          $scope.$broadcast('focusOn', 'modal-close');
        });
      };

      // Question mark button on title bar for the lumen step
      ctrl.closeModalLumen = function () {
        ctrl.active = false;
        $scope.$broadcast('focusOn', 'modal-open');
      };

      ctrl.getTypeSelection = function () {
        if (ctrl.disabled !== 'true') {
          ctrl.stepName = 'type';
          ctrl.zoomModal = false;
          ctrl.options = hqTLightingOptions.types;
          ctrl.selection = hqTLightingOptions.typeSelection;
          ctrl.isValid = ctrl.isSelectionValid();
        }
      };

      ctrl.slickConfig = {
        dots: true,
        accessibility: true,
        waitForAnimate: false,
        event: {
          afterChange: function slickAfterChange(event, slick, currentSlide) {
            var translateKey = slick.$slides
              .eq(currentSlide)
              // eslint-disable-next-line es5/no-es6-methods
              .find('.hq-lighting-list-item')
              .attr('data-translate-key');

            if (ctrl.selection === translateKey) return;

            ctrl.selection = translateKey;
            hqTLightingOptions[ctrl.stepName + 'Selection'] = translateKey;
          },
          init: function slickInit(event, slick) {
            // Remember state if user decides to go back a step.
            var slide;

            if (hqTLightingOptions[ctrl.stepName + 'Selection'] === null) {
              slick.slickGoTo(0);
              ctrl.isValid = true;
            } else {
              if (ctrl.stepName === 'type') {
                ctrl.isValid = true;
              }
              slick.$slides.each(function (item) {
                var slideCheck = slick
                  .$slides
                  .eq(item)
                  // eslint-disable-next-line es5/no-es6-methods
                  .find('[data-translate-key="' + hqTLightingOptions[ctrl.stepName + 'Selection'] + '"]')
                  .length;

                if (slideCheck) {
                  slide = item;
                }
              });
              slick.slickGoTo(slide);
            }
          },
        },
      };
    };
  }

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingStepSelection', component);
}());
